<ng-container *transloco="let t; read: 'ime.common.hierarchy-nodes'">
  <div class="modal-header" ngxModalDraggable>
    <h4 class="modal-title pull-left">{{t('Hierarchy')}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(selectedIds)">
    </button>
  </div>
  <div class="modal-body ms-n8">
    <ng-container *ngFor="let node of rootNode?.Children" [ngTemplateOutlet]="nodeTmpl" [ngTemplateOutletContext]="{node: node}"></ng-container>
    <ng-template #nodeTmpl let-node="node">
      <div class="row ms-8 mt-1">
        <div class="col-auto px-0 my-auto">
          <a class="m-1" (click)="node.IsExpanded = !node.IsExpanded">
            <svg viewBox="0 0 8 8" class="icon mb-1" [inlineSVG]="node.IsExpanded ? '#chevron-down' : '#chevron-right'">
            </svg>
          </a>
          <p-checkbox [ngModel]="node.IsSelected" (onChange)="onSelect($event, node)" binary="true" inputId="checkBox-{{node.Id}}" class="m-1"></p-checkbox>
        </div>
        <div class="col-auto px-0">
          <input type="text" class="form-control" [(ngModel)]="node.Name" [disabled]="readonly" (blur)="ensureSaveChanges(node)">
        </div>
        <div *ngIf="!readonly" class="col-auto px-0">
          <button class="btn btn-outline-primary ms-1" (click)="addChild(node)">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
            {{t('Add child')}}
          </button>
          <button type="button" *ngIf="!node.Children.length" class="btn btn-outline-danger ms-1" (click)="remove(node)">
            <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#trash"></svg>
          </button>
        </div>
        <ng-container *ngIf="node.IsExpanded">
          <ng-container *ngFor="let child of node.Children">
            <ng-container [ngTemplateOutlet]="nodeTmpl" [ngTemplateOutletContext]="{node: child}"></ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </div>
</ng-container>
